module.exports = __webpack_public_path__ + "static/media/1.b0fe1cf2.png";